let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("c0Gcr")).then(() => parcelRequire('jG4Gc'));